// extracted by mini-css-extract-plugin
export default {"area":"FL6T9t","mobile":"QadObr","label":"aXFYSC","occupiedArea":"fHqFUJ"};